"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workPlaceRelationshipToApplicant = void 0;
const enums_1 = require("@bemlo/enums");
exports.workPlaceRelationshipToApplicant = {
    [enums_1.WorkPlaceRelationshipToApplicant.COWORKER]: 'Kollega',
    [enums_1.WorkPlaceRelationshipToApplicant.SUBORDINATE]: 'Underordnet',
    [enums_1.WorkPlaceRelationshipToApplicant.SUPERIOR]: 'Sjef',
};
